
<div class="container-fluid p-3">
  <div class="d-flex">
    <div class="settingsmenu bg-white rounded-left shadow-sm mt-2 mb-2">
      <router-link
        tag="div"
        class="menuitem"
        :class="{ active: $route.name === routes.settings }"
        :to="{
          name: routes.settings,
          params: { id: $route.params.id },
        }"
      >
        <i class="far fa-cog"></i>
        <div class="nav-item-title">Basic Settings</div>
      </router-link>

      <router-link
        tag="div"
        class="menuitem"
        :class="{ active: $route.name === routes.shiftValidationSettings }"
        :to="{
          name: routes.shiftValidationSettings,
          params: { id: $route.params.id },
        }"
      >
        <i class="far fa-check-square"></i>
        <div class="nav-item-title">Categories/ Types</div>
      </router-link>

      <router-link
        tag="div"
        class="menuitem"
        :class="{ active: $route.name === routes.labels.boardLabels.name }"
        :to="{
          name: routes.labels.boardLabels.name,
          params: { id: $route.params.id },
        }"
      >
        <i class="far fa-tags"></i>
        <div class="nav-item-title">Board Labels</div>
      </router-link>

      <router-link
        tag="div"
        class="menuitem"
        :class="{ active: $route.name === routes.biTemplates }"
        :to="{
          name: routes.biTemplates,
          params: { id: $route.params.id },
        }"
      >
        <i class="far fa-file-invoice"></i>
        <div class="nav-item-title">Templates</div>
      </router-link>

      <router-link
        tag="div"
        class="menuitem"
        :class="{ active: $route.name === routes.emailToBoard }"
        :to="{
          name: routes.emailToBoard,
          params: { id: $route.params.id },
        }"
      >
        <i class="far fa-mail-bulk"></i>
        <div class="nav-item-title">E-Mail2Board</div>
      </router-link>

      <router-link
        tag="div"
        class="menuitem"
        :class="{ active: $route.name === routes.sendAsEmailSettings }"
        :to="{
          name: routes.sendAsEmailSettings,
          params: { id: $route.params.id },
        }"
      >
        <i class="far fa-mail-bulk"></i>
        <div class="nav-item-title">Send as Email</div>
      </router-link>
    </div>

    <div class="bg-lightgray rounded-sm flex-grow-1 p-4 pl-5 pt-4 shadow-sm settingscontainer shadow-sm">
      <div style="min-width: 800px; max-width: 1550px">
        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
